import React, {useMemo} from "react";
import {CommentHighlight} from "../../SearchResult";
import {Label14, Text16} from "../../../../common/components/typography/Typography";
import {Highlight} from "./Highlight";
import {format} from "date-fns";
import styles from "./CommentHighlightCard.module.css";

interface CommentHighlightCardProps {
    highlight: CommentHighlight;
}

export default function CommentHighlightCard({highlight}: CommentHighlightCardProps) {
    const timestamp = useMemo(() => format(highlight.created, "dd.MM.yyyy 'at' HH:mm"), [highlight]);

    return (
        <div className={styles.card}>
            <Label14 color="gray-42">{timestamp}</Label14>

            <div className={styles.text}>
                <Text16 lineHeight={1.5}>
                    <Highlight highlights={highlight.textHighlights}/>
                </Text16>
            </div>
        </div>
    );
}
